module.exports = __webpack_public_path__ + "media/images/icons/icon-dashboard-636834b875dfa667a16c8ec54d229c9d.png";